// src/components/TestCategoryButton.jsx
// Simple test component to verify CategoryButton functionality

import React from 'react';
import CategoryButton from './CategoryButton';

const TestCategoryButton = () => {
  const testCategory = {
    name: "Test Category",
    image: "/assets/img/categories/black-white.jpg",
    color: "#2F2F2F",
    subCategories: [
      { name: "Test Sub 1", iframeLink: "test1", icon: "👨" },
      { name: "Test Sub 2", iframeLink: "test2", icon: "👩" }
    ]
  };

  return (
    <div className="p-4">
      <h2>Test Category Button</h2>
      <CategoryButton category={testCategory} />
    </div>
  );
};

export default TestCategoryButton; 